<template>
  <div id="app">
    <Nav/>
    <router-view/>
    <Download/>
    <Foot/>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
  import Foot from '@/components/Foot'
  import Download from '@/components/Download'

  export default {
    components: { Nav, Foot, Download },
    name: 'App'
  }
</script>

<style lang="scss">
  @import "./styles/common.scss";
  @import "./styles/stylefunc";
  #app {
    padding-top: px2rem(51px);
    background-color: #f2f2f2;
    section {
      padding: px2rem(10px);
      background-color: #FFF;
    }
    /*section:not(.nav-link-box) {
      margin-top: px2rem(10px);
    }*/
    /* Gellery img 列表容器样式 */
    .list-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
    }
    /* tag 容器样式 */
    .tag-list {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue